module.exports = require("lodash/head");